<template>
	<main :class="{en: globalLang === 'en' || globalLang === 'th' || globalLang === 'vi'}">

		<!-- 导航 -->
        <navbar active="4" @changeTab="changeTab"></navbar>

		<div class="info-con" v-if="pageType === 'info'">
			<div class="detail-wrap">
				<div class="info-line">
					<div class="grid-content">
						<div class="detail-tit">{{$t('service.account')}}</div>
						<div>{{account.tel}}</div>
					</div>
					<div class="grid-content">
						<div class="detail-tit">{{$t('service.uname')}}</div>
						<div>{{account.nickName}}</div>
					</div>
				</div>
				<div class="info-line">
					<div class="grid-content">
						<div class="detail-tit">{{$t('service.telName')}}</div>
						<div>{{contact.contacts}}</div>
					</div>
					<div class="grid-content">
						<div class="detail-tit">{{$t('service.sex')}}</div>
						<div>{{sex[contact.sex]}}</div>
					</div>
				</div>
				<div class="info-line">
					<div class="grid-content">
						<div class="detail-tit">{{$t('service.telphone')}}</div>
						<div>{{contact.mobile}}</div>
					</div>
					<div class="grid-content">
						<div class="detail-tit">{{$t('service.useEmail')}}</div>
						<div>{{contact.email}}</div>
					</div>
				</div>
				<div class="info-line">
					<div class="grid-content">
						<div class="detail-tit">{{$t('service.address')}}</div>
						<div>{{contact.address}}</div>
					</div>
					<!-- <div class="grid-content">
						<div class="detail-tit">LIne Notify</div>
						<div>未綁定</div>
					</div> -->
				</div>
			</div>
			<div class="top-btn center" @click="initEdit" ga-data="2101001">{{$t('service.editInfo')}}</div>
		</div>

		<div class="info-con" v-if="pageType === 'edit'">
			<div class="detail-wrap shorter">
				<div class="info-line">
					<div class="grid-content">
						<div class="edit-tit">{{$t('service.account')}}</div>
						<k-input :placeholder="$t('service.inputAccount')" v-model="account.tel" class="readonly"></k-input>
					</div>
					<div class="grid-content">
						<div class="edit-tit">{{$t('service.uname')}}</div>
						<k-input :placeholder="$t('service.inputUname')" v-model="account.nickName" class="readonly"></k-input>
					</div>
				</div>
				<div class="info-line">
					<div class="grid-content">
						<div class="edit-tit">{{$t('service.telName')}}</div>
						<k-input :placeholder="$t('service.writeName')" :validOptions="rules.name" v-model="editOptions.contacts"></k-input>
					</div>
					<div class="grid-content">
						<div class="edit-tit">{{$t('service.sex')}}</div>
						<k-select :selected="selectedSex" :options="sexOptions" @selectedOption="selectSex" class="code-area"></k-select>
					</div>
				</div>
				<div class="info-line">
					<div class="grid-content">
						<div class="edit-tit">{{$t('service.telphone')}}</div>
						<k-input :placeholder="$t('service.writeTel')" :validOptions="rules.phone" v-model="editOptions.mobile"></k-input>
					</div>
					<div class="grid-content">
						<div class="edit-tit">{{$t('service.useEmail')}}</div>
						<k-input :placeholder="$t('service.inputEmail')" :validOptions="rules.email" v-model="editOptions.email"></k-input>
					</div>
				</div>
				<div class="info-line">
					<div class="grid-content">
						<div class="edit-tit">{{$t('service.address')}}</div>
						<k-input :placeholder="$t('service.writeAddress')" class="en-address" :validOptions="rules.address" v-model="editOptions.address"></k-input>
					</div>
					<!-- <div class="grid-content">
						<div class="edit-tit">LIne Notify</div>
						<div>未綁定</div>
					</div> -->
				</div>
			</div>
			<div class="center-area">
				<div class="top-btn reverse" @click="pageType = 'info'" ga-data="2103001">{{$t('service.cancel')}}</div>
				<div class="top-btn" :class="{'not-allowed': !submitReady || submitBusy}" @click="saveContacts" ga-data="2102001">{{$t('service.save')}}</div>
			</div>
		</div>

	</main>
</template>

<script>
	import KInput from './component/kinput';
    import KSelect from '@/component/select/select.vue';
	import navbar from "./component/navbar";
	
	export default {
		name: "info",
		data() {
			var validPhone = (value, callback) => {
                value += '';
                if (!value) {
					this.submitReady = true;
                    return callback(new Error('valid'));
                }else {
                    if (!value.match("^[0-9]{6,20}$")){
						this.submitReady = false;
                        return callback(new Error(this.$t('service.writeValidTel')));
                    }else{
						this.submitReady = true;
                        return callback(new Error('valid'));
                    }
                }
            };
            var validName = (value, callback) => {
                value += '';
                if (!value) {
					this.submitReady = true;
                    return callback(new Error('valid'));
                }else {
                    if (value.length < 2 || value.length > 20){
                        this.submitReady = false;
                        return callback(new Error(this.$t('service.vaildTelName')));
                    }else{
						this.submitReady = true;
                        return callback(new Error('valid'));
                    }
                }
			};
			var validEmail = (value, callback) => {
				value += '';
				let eReg = /^[A-Za-z0-9._%-]+@([A-Za-z0-9-]+\.)+[A-Za-z]{2,4}$/;
                if (!value) {
					this.submitReady = true;
                    return callback(new Error('valid'));
                }else {
					if(value.length > 50){
						this.submitReady = false;
                        return callback(new Error(this.$t('service.writeValidEmail')));
					}
                    if (!eReg.test(value)){
                        this.submitReady = false;
                        return callback(new Error(this.$t('service.writeValidEmail')));
                    }else{
						this.submitReady = true;
                        return callback(new Error('valid'));
                    }
                }
			};
			var validAddress = (value, callback) => {
                value += '';
                if (!value) {
					this.submitReady = true;
                    return callback(new Error('valid'));
                }else {
                    if (value.length > 50){
                        this.submitReady = false;
                        return callback(new Error(this.$t('service.vaildAddress')));
                    }else{
						this.submitReady = true;
                        return callback(new Error('valid'));
                    }
                }
            };
			return {
				pageType: 'info',
				editOptions: {},
				account: {},
				contact: {},
				sex: [
					this.$t('service.keepSecret'),
					this.$t('service.male'),
					this.$t('service.female')
				],
				selectedSex: {},
				sexOptions: [
					{
						id: 0,
						val: this.$t('service.keepSecret')
					},
					{
						id: 1,
						val: this.$t('service.male')
					},
					{
						id: 2,
						val: this.$t('service.female')
					}
				],
				rules: {
                    phone: [
                        { validator: validPhone, trigger: 'blur' }
                    ],
                    name: [
                        { validator: validName, trigger: 'blur' }
					],
					email: [
                        { validator: validEmail, trigger: 'blur' }
                    ],
                    address: [
                        { validator: validAddress, trigger: 'blur' }
                    ]
				},
				submitReady: true,
				submitBusy: false
			};
		},
		components: {
			KInput,
			KSelect,
			navbar
		},
		methods: {
			initEdit (){
				this.pageType = 'edit';

				if(!this.account.tel){
					this.account.tel = 'N/A';
				}

				this.editOptions = {
					contacts: this.contact.contacts || '',
					mobile: this.contact.mobile || '',
					email: this.contact.email || '',
					address: this.contact.address || ''
				};
				this.selectedSex = {
					id: this.contact.sex || 0,
					val: this.sex[this.contact.sex] || this.$t('service.keepSecret')
				};
			},
			saveContacts (){
				this.submitBusy = true;

				var params = {
					contacts: this.editOptions.contacts,
					mobile: this.editOptions.mobile,
					email: this.editOptions.email,
					address: this.editOptions.address
				};
				params.sex = this.selectedSex.id;

				this.$apis.service.saveConnectInfo(params.contacts, params.sex, params.mobile, params.email, params.address, this.$utils.token("joy_jct")).then(res => {
					if (res.data.code == 0) {
						this.getInfo();
						this.pageType = 'info';
					} else {
						alert(this.$t(`serviceCode.${res.data.code}`) ||res.data.message|| this.$t('service.submitFail') );
					}

					this.submitBusy = false;
				});
			},
			selectSex (item){
				this.selectedSex = item;
			},
			getInfo (){
				this.$apis.service.getConnectInfo(this.$utils.token("joy_jct")).then(res => {
					if (res.data.code == 0) {
						this.contact = res.data.data;
					}
				});
			},
			// 切换导航栏
			changeTab(url) {
				this.$router.push({
						path: url
				});
			},
		},
		created: function() {
			// 登录态判断
			this.$apis.common.getUserInfo(this.$utils.token("joy_jct")).then(res => {
				if (res.data.code == 0) {
					this.account = res.data.data;
					if(!this.account.tel){
						this.account.tel = 'N/A';
					}
					if(this.account.email){
						this.account.tel = this.account.email;
					}
					if(this.account.nick_name){
						this.account.nickName = this.account.nick_name;
					}
				} else {
					this.$router.push({name: 'login', query: { redirect: encodeURIComponent(location.href) }  });
				}
			});

			this.getInfo();
		},
		mounted: function() {
		}
	};
</script>

<style lang="scss" scoped>
	.en {
		/deep/ .k-input-input {
			border-width: 1px;
		}
		.info-con .code-area {
			width: 500px;
			border-width: 1px;
		}
		.info-con .k-input-wrapper {
			width: 500px;
			&.en-address {
				width: 1080px;
			}
		}
	}
	/deep/ .info-con {
		width: 1170px;
		margin: 0 auto;
		min-height: 706px;
		color: #444;
		.code-area {
			width: 400px;
			height: 50px;
			line-height: 46px;
			border-radius: 50px;
			border: 2px solid #CCCCCC;
		}
		.selected {
			position: relative;
			color: inherit !important;
			.sel-arr {
				position: absolute;
				top: 0;
				right: 32px;
				width: 12px;
				height: 100%;
				border: none;
				background: url('../images/arrow_down_circle.svg') no-repeat;
				background-size: 100% auto;
				background-position: center;
			}
		}
		.k-popover {
			border-radius: 12px !important;
		}
		.readonly {
			input {
				background-color: #eee;
				pointer-events: none;
			}
		}
		.k-input-wrapper {
			width: 400px;
			margin-bottom: 15px;
		}
		.detail-wrap {
			padding: 20px 0;
			font-size: 14px;
			border-bottom: 1px solid #eee;
		}
		.edit-tit {
			padding: 20px 0;
			font-size: 16px;
		}
		.shorter {
			.info-line {
				padding: 0;
			}
		}
		.info-line {
			padding: 10px 0;
			&:before,
			&:after {
				content: "";
				display: table;
				font-size: 0;
			}
			&:after {
				clear: both;
			}
			.grid-content {
				float: left;
				width: 50%;
			}
		}
		.detail-des {
			line-height: 21px;
		}
		.detail-tit {
			padding: 10px 0;
			font-size: 12px;
			color: #BDBDBD;
			&.big {
				font-size: 16px;
				color: #444444;
			}
		}
		.top-btn {
			width: 240px;
			height: 40px;
			line-height: 40px;
			background: #50BBE5;
			border-radius: 100px;
			font-size: 16px;
			color: #FFFFFF;
			text-align: center;
			cursor: pointer;
			transition: box-Shadow 0.3s;
			&.not-allowed {
				background-color: #ccc;
				pointer-events: none;
			}
			&:hover {
				box-shadow: 0 4px 6px 0 rgba(10,131,186,0.3);
			}
			&.reverse{
				margin-right: 30px;
				color: #50BBE5;
				background: #FFFFFF;
				border: 1px solid #50BBE5;
				pointer-events: auto;
			}
			&.center {
				margin: 0 auto;
				margin-top: 40px;
			}
		}
		.center-area {
			width: 515px;
			margin: 0 auto;
			margin-top: 40px;
			&:before,
			&:after {
				content: "";
				display: table;
				font-size: 0;
			}
			&:after {
				clear: both;
			}
			.top-btn {
				float: left;
				margin: 0;
				&.reverse {
					margin-right: 30px;
				}
			}
		}
		.info-line .k-input-input {
			line-height: 30px;
		}
	}
</style>
